<template>
    <v-container style="padding: 0 10%">
        <vueHeadful
        :title="this.$i18n.t('Menu.AdministracionContratos') + ' - TrArtist'"
        :url="'https://trartist.com' + $route.fullPath"
        />
        <v-row>
            <v-col cols="12">
              <v-text-field solo v-model="buscar" :label="$t('Busqueda.Buscar')"></v-text-field>
                <v-data-table
                :search="buscar"
                :headers="headers"
                :items="contratos">
                <template v-slot:[`item.pais`]="{ item }">
                    <span v-if="item.pais">{{item.pais}}, {{item.departamento}}, {{item.ciudad}}</span>
                </template>
                <template v-slot:[`item.aprobado`]="{ item }">
                  <v-icon color="green" v-if="item.aprobado && item.revisado">fas fa-check</v-icon>
                  <v-icon color="red" v-if="!item.aprobado && item.revisado">fas fa-times</v-icon>
                  <v-icon v-if="!item.revisado">far fa-clock</v-icon>
                </template>
                <template v-slot:[`item.ver`]="{ item }">
                    <v-btn icon @click="abrirDialog(item)"><v-icon color="black">far fa-eye</v-icon></v-btn>
                </template>
                </v-data-table>
                <v-dialog v-model="dialog">
                  <v-card v-if="elegido">
                    <v-card-title>
                      <v-container>
                        <v-row>
                          <v-col cols="12" align="center">
                            <h1>Revisar Contrato</h1>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field solo v-model="elegido.nombre" readonly :hint="$t('Formularios.Nombre')" persistent-hint />
                          </v-col>
                          <v-col cols="12">
                            <v-text-field solo v-model="elegido.tipoDocumento" readonly :hint="$t('Pago.TipoDocumento')" persistent-hint />
                          </v-col>
                          <v-col cols="12">
                            <v-text-field solo v-model="elegido.documento" readonly :hint="$t('Pago.NumeroDocumento')" persistent-hint />
                          </v-col>
                          <v-col cols="12">
                            <v-text-field solo v-model="elegido.pais" readonly :hint="$t('Formularios.Pais')" persistent-hint />
                          </v-col>
                          <v-col cols="12">
                            <v-text-field solo v-model="elegido.departamento" readonly :hint="$t('Formularios.Departamento')" persistent-hint />
                          </v-col>
                          <v-col cols="12">
                            <v-text-field solo v-model="elegido.ciudad" readonly :hint="$t('Formularios.Ciudad')" persistent-hint />
                          </v-col>
                          <v-col cols="12" align="center">
                            <v-btn color="black white--text" x-large style="min-width:20%!important" :href="elegido.urlContrato" target="_blank">{{$t('Formularios.VerContrato')}}</v-btn>
                          </v-col>
                          <v-col cols="12">
                            <v-textarea v-model="comentario" :label="$t('Formularios.ComentarioDelModerador')" :hint="$t('Formularios.ComentarioDelModerador')" persistent-hint solo />
                          </v-col>
                          <v-col cols="12" align="center">
                            <h2 class="mb-3">Estado</h2>
                            <v-icon color="green" v-if="elegido.aprobado && elegido.revisado">fas fa-check</v-icon>
                            <v-icon color="red" v-if="!elegido.aprobado && elegido.revisado">fas fa-times</v-icon>
                            <v-icon v-if="!elegido.revisado">far fa-clock</v-icon>
                          </v-col>
                          <v-col cols="12" align="center" class="mt-5">
                            <v-btn :loading="getCargandoAccion" outlined class="ma-4" style="border: 2px solid" large @click="dialog = false">{{$t('Formularios.Cerrar')}}</v-btn>
                            <v-btn :loading="getCargandoAccion" outlined class="ma-4" style="border: 2px solid" large @click="rechazar()">{{$t('Administracion.Rechazar')}}</v-btn>
                            <v-btn :loading="getCargandoAccion" outlined class="ma-4" style="border: 2px solid" large @click="aprobar()">{{$t('Administracion.Aprobar')}}</v-btn>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-title>
                  </v-card>
                </v-dialog>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import { mapMutations, mapActions, mapGetters } from 'vuex'
export default {
  name: 'AdministracionContratos',
  data () {
    return {
      buscar: null,
      dialog: false,
      elegido: null,
      indexElegido: null,
      comentario: null,
      contratos: [],
      headers: [
        { text: this.$i18n.t('Formularios.Nombre'), value: 'nombre' },
        { text: this.$i18n.t('Formularios.Pais'), value: 'pais' },
        { text: this.$i18n.t('Formularios.Aprobado'), value: 'aprobado' },
        { text: this.$i18n.t('Formularios.Ver'), value: 'ver' }
      ]
    }
  },
  computed: {
    ...mapGetters(['getCargandoAccion'])
  },
  methods: {
    ...mapMutations(['setAlerta', 'setTextoAlerta', 'setCargandoAccion']),
    ...mapActions(['enviarCorreo']),
    abrirDialog (item) {
      this.indexElegido = this.contratos.indexOf(item)
      this.elegido = item
      this.dialog = true
    },
    aprobar () {
      this.setCargandoAccion(true)
      firebase.firestore().collection('usuarios').doc(this.elegido.uid).update({
        revision: true,
        contratoAprobado: true
      })
        .then(() => {
          firebase.firestore().collection('contratos').doc(this.elegido.uid).update({
            revisado: true,
            aprobado: true
          })
            .then(() => {
              this.enviarCorreo({
                email: 'TrArtist <soycliente@trartist.com>',
                destino: this.elegido.email,
                asunto: 'Tu contrato ha sido aprobado',
                texto: `<span>Hola ${this.elegido.nombre},</span>
                <br><br>
                <span>Tu contrato ha sido aprobado y si tu perfil está completo puedes empezar a vender.</span>
                <br><br>
                <span>Recuerda seguir todos los lineamientos de la sección de capacitación que se encuentra en el BackOffice, te deseamos muchos éxitos.</span>
                <br><br>
                <span>Un saludo,</span>
                <br>
                <span><b>Equipo TrArtist</b></span>
                <br>
                <img src="https://firebasestorage.googleapis.com/v0/b/trartist-com.appspot.com/o/utilidades%2FlogoFirma.png?alt=media&token=06daf706-dfb9-4c87-bc69-a8c9464dd0af"/>`
              })
                .then(() => {
                  this.contratos[this.indexElegido].aprobado = true
                  this.contratos[this.indexElegido].revisado = true
                  this.setCargandoAccion(false)
                  this.setAlerta()
                  this.setTextoAlerta('Alerta.InformacionActualizada')
                  this.dialog = false
                })
            })
        })
    },
    rechazar () {
      this.setCargandoAccion(true)
      firebase.firestore().collection('usuarios').doc(this.elegido.uid).update({
        revision: true,
        contratoAprobado: false,
        contratoSubido: false
      })
        .then(() => {
          firebase.firestore().collection('contratos').doc(this.elegido.uid).update({
            revisado: true,
            aprobado: false,
            contratoSubido: false
          })
            .then(() => {
              this.enviarCorreo({
                email: 'TrArtist <soycliente@trartist.com>',
                destino: this.elegido.email,
                asunto: 'Tu contrato no ha sido aceptado',
                texto: `<span>Hola ${this.elegido.nombre},</span>
                <br><br>
                <span>Tu contrato no ha sido aceptado por los siguientes motivos:</span>
                <br><br>
                <span>${this.comentario}</span>
                <br><br>
                <span>Un saludo,</span>
                <br>
                <span><b>Equipo TrArtist</b></span>
                <br>
                <img src="https://firebasestorage.googleapis.com/v0/b/trartist-com.appspot.com/o/utilidades%2FlogoFirma.png?alt=media&token=06daf706-dfb9-4c87-bc69-a8c9464dd0af"/>`
              })
                .then(() => {
                  this.contratos[this.indexElegido].aprobado = false
                  this.contratos[this.indexElegido].revisado = true
                  this.setCargandoAccion(false)
                  this.setAlerta()
                  this.setTextoAlerta('Alerta.InformacionActualizada')
                  this.dialog = false
                })
            })
        })
    }
  },
  mounted () {
    firebase.firestore().collection('contratos').get().then(info => {
      for (let i = 0; i < info.docs.length; i++) {
        this.contratos.push(info.docs[i].data())
      }
    })
  }
}
</script>
